// Sample the real card alpha outlines, rather than treating transparent padding
// or the card's rectangular image box as an edge beneath the tape.
export const renderTapeContact = (element, surfaces) => {
  const cards = surfaces.filter((surface) => surface.image && surface.z < element.z);
  if (!cards.length) return null;
  const canvas = document.createElement("canvas");
  canvas.width = 320;
  canvas.height = Math.max(1, Math.round(320 * element.height / element.width));
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (!context) return null;
  context.scale(canvas.width / element.width, canvas.height / element.height);
  context.translate(element.width / 2, element.height / 2);
  context.rotate(-element.rotation * Math.PI / 180);
  context.translate(-element.x, -element.y);
  for (const card of cards) {
    context.save();
    context.translate(card.x, card.y);
    context.rotate(card.rotation * Math.PI / 180);
    const {crop} = card;
    context.drawImage(card.image, crop.x, crop.y, crop.width, crop.height, -card.width / 2, -card.height / 2, card.width, card.height);
    context.restore();
  }
  const width = canvas.width;
  const height = canvas.height;
  let mask;
  try { mask = context.getImageData(0, 0, width, height).data; } catch { return null; }
  const edges = new Float32Array(width * height);
  let hasEdge = false;
  for (let y = 1; y < height - 1; y += 1) {
    for (let x = 1; x < width - 1; x += 1) {
      const index = y * width + x;
      const alpha = mask[index * 4 + 3];
      const differences = [index - 1, index + 1, index - width, index + width].map((neighbor) => Math.abs(alpha - mask[neighbor * 4 + 3]));
      const strength = Math.max(...differences) / 255;
      if (strength > 0.08) { edges[index] = strength; hasEdge = true; }
    }
  }
  if (!hasEdge) return null;
  const edgeCanvas = document.createElement("canvas");
  edgeCanvas.width = width;
  edgeCanvas.height = height;
  const edgeContext = edgeCanvas.getContext("2d");
  const output = edgeContext.createImageData(width, height);
  // A small Gaussian blur gives the raised edge a soft contact shadow.
  const kernel = [1, 2, 1];
  for (let y = 1; y < height - 1; y += 1) {
    for (let x = 1; x < width - 1; x += 1) {
      let darkness = 0;
      for (let dy = -1; dy <= 1; dy += 1) for (let dx = -1; dx <= 1; dx += 1) {
        darkness += edges[(y + dy) * width + x + dx] * kernel[dy + 1] * kernel[dx + 1] / 16;
      }
      const index = (y * width + x) * 4;
      output.data[index] = 48;
      output.data[index + 1] = 35;
      output.data[index + 2] = 18;
      output.data[index + 3] = Math.round(darkness * (element.decoration === "clear-tape" ? 65 : 85));
    }
  }
  edgeContext.putImageData(output, 0, 0);
  return edgeCanvas;
};
